import React from 'react';

export const Dot = ({ width = 4, height = 4, className = '' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 4 4"
    fill="none"
  >
    <rect width="4" height="4" rx="2" fill="currentColor" />
  </svg>
);
